import React, { memo } from 'react'

import { CircleCheck, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'

function CurrentModelCard({ thumbUrl = '', title }) {
  return (
    <div className="visual-references__current">
      <span className="visual-references__current-thumb">
        {thumbUrl ? (
          <img src={thumbUrl} alt={title} className="visual-references__current-image" decoding="async" />
        ) : null}
      </span>
      <span className="visual-references__current-title cgt-body-base-semibold" title={title}>{title}</span>
      <Icon svgComponent={CircleCheck} color="positive" size={iconSizeMedium} notSpaced />
    </div>
  )
}

CurrentModelCard.propTypes = {
  thumbUrl: string,
  title: string.isRequired,
}

export default memo(CurrentModelCard)
